// Notices a customer has sent but not paid for yet (owner 28-10-2569: send every notice first, then pay one total).
// Kept in this browser only: each notice is already saved on the server; the basket just remembers which tracking
// codes go into the next payment, and the contact so the next form starts filled in. All notices of one payment must
// use the same phone (the server checks it), so a notice sent with another phone starts a new basket.
const KEY = "mng_notice_basket";
const LAST_ORDER = "mng_last_order";
const EMPTY = { contact: { contactName: "", phone: "", companyName: "" }, items: [] };

const digits = (p) => String(p || "").replace(/\D/g, "");

function readJson(key, fallback) {
  try {
    const v = JSON.parse(localStorage.getItem(key) || "null");
    return v && typeof v === "object" ? v : fallback;
  } catch {
    return fallback;
  }
}
function writeJson(key, value) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* private window / storage blocked — the basket then lives only on this page */
  }
}

export function readBasket() {
  const b = readJson(KEY, EMPTY);
  return { contact: { ...EMPTY.contact, ...(b.contact || {}) }, items: Array.isArray(b.items) ? b.items : [] };
}

// returns { basket, restarted } — restarted = the earlier notices used another phone
export function addToBasket({ trackingCode, title }, contact = {}) {
  const current = readBasket();
  const restarted = current.items.length > 0 && digits(current.contact.phone) !== digits(contact.phone);
  const base = restarted ? EMPTY : current;
  const items = base.items.some((i) => i.trackingCode === trackingCode)
    ? base.items
    : [...base.items, { trackingCode, title: title || "ประกาศ", at: new Date().toISOString() }];
  const basket = {
    contact: { contactName: contact.contactName || "", phone: contact.phone || "", companyName: contact.companyName || "" },
    items,
  };
  writeJson(KEY, basket);
  return { basket, restarted };
}

export function removeFromBasket(trackingCode) {
  const b = readBasket();
  const next = { ...b, items: b.items.filter((i) => i.trackingCode !== trackingCode) };
  writeJson(KEY, next);
  return next;
}

export function clearBasket() {
  const b = readBasket();
  writeJson(KEY, { ...EMPTY, contact: b.contact }); // keep the contact for the next notice
}

export const saveLastOrder = (order, phone) => writeJson(LAST_ORDER, { ...order, phone });
export const readLastOrder = () => readJson(LAST_ORDER, null);
